import { useEffect, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Home = lazy(() => import("@/pages/Home"));
const Services = lazy(() => import("@/pages/Services"));
const Gallery = lazy(() => import("@/pages/Gallery"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const ServiceLanding = lazy(() => import("@/pages/ServiceLanding"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);
  return children;
};

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Header />
          <main>
          <Suspense fallback={<div className="min-h-screen bg-white" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/roof-repair-winnipeg" element={<ServiceLanding slug="roof-repair-winnipeg" />} />
              <Route path="/roof-replacement-winnipeg" element={<ServiceLanding slug="roof-replacement-winnipeg" />} />
              <Route path="/roofing-contractor-winnipeg" element={<ServiceLanding slug="roofing-contractor-winnipeg" />} />
              <Route path="/residential-roofing-winnipeg" element={<ServiceLanding slug="residential-roofing-winnipeg" />} />
              <Route path="/hail-damage-roof-repair-winnipeg" element={<ServiceLanding slug="hail-damage-roof-repair-winnipeg" />} />
              <Route path="/emergency-roof-repair-winnipeg" element={<ServiceLanding slug="emergency-roof-repair-winnipeg" />} />
              <Route path="/asphalt-shingle-roofing-winnipeg" element={<ServiceLanding slug="asphalt-shingle-roofing-winnipeg" />} />
              <Route path="/ice-dam-removal-winnipeg" element={<ServiceLanding slug="ice-dam-removal-winnipeg" />} />
              <Route path="/roof-inspection-winnipeg" element={<ServiceLanding slug="roof-inspection-winnipeg" />} />
              <Route path="/attic-ventilation-winnipeg" element={<ServiceLanding slug="attic-ventilation-winnipeg" />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
            </Routes>
          </Suspense>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
